/** Ana sayfa hero — gerçek sayıları doğrudan göstermeden tahmini değer üretir */

export type PublicStatKind = 'notes' | 'downloads' | 'users';

const FALLBACK_ESTIMATES: Record<PublicStatKind, number> = {
  notes: 150,
  downloads: 750,
  users: 90,
};

function roundUpToStep(value: number, step: number): number {
  return Math.ceil(value / step) * step;
}

function vagueRound(raw: number): number {
  if (raw < 20) return 20;
  if (raw < 100) return roundUpToStep(raw, 10);
  if (raw < 500) return roundUpToStep(raw, 25);
  if (raw < 2000) return roundUpToStep(raw, 50);
  if (raw < 10000) return roundUpToStep(raw, 100);
  return roundUpToStep(raw, 500);
}

export interface EstimatedPublicStat {
  value: number;
  prefix: string;
  suffix: string;
}

export function estimatePublicStat(
  raw: number | null | undefined,
  kind: PublicStatKind
): EstimatedPublicStat {
  const hasReal = typeof raw === 'number' && raw > 0;
  const base = hasReal ? vagueRound(raw) : FALLBACK_ESTIMATES[kind];

  return {
    value: base,
    prefix: '~',
    suffix: '+',
  };
}
